import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { SIGNS, SITE } from "../../data/site";

export const Threat = () => (
  <section
    id="signs"
    data-testid="signs-section"
    className="relative bg-[#F0ECE6] text-[#1C1B1A] py-24 md:py-32 grain-light overflow-hidden"
  >
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
      <div className="grid grid-cols-12 gap-6 mb-14 items-end">
        <div className="col-span-12 lg:col-span-7">
          <div className="text-[#C05746] text-xs md:text-sm font-semibold tracking-[0.24em] uppercase mb-4">
            Know the enemy
          </div>
          <h2 className="font-display text-[#1C1B1A] text-4xl md:text-5xl lg:text-[4.5rem] leading-[1.02] tracking-tight">
            Silent destroyers
            <br />
            leave <span className="font-serif-accent italic text-[#C05746]">loud</span> evidence.
          </h2>
        </div>
        <div className="col-span-12 lg:col-span-5 lg:text-right">
          <p className="text-[#5C5A55] text-base md:text-lg leading-relaxed max-w-md lg:ml-auto">
            A colony can feed for 5–7 years before you ever see damage.
            These four signs mean termites are already in the wood. Call us today.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {SIGNS.map((s, i) => (
          <motion.article
            key={s.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="group relative"
            data-testid={`sign-card-${i}`}
          >
            <div className="aspect-[4/5] overflow-hidden bg-[#E5DFD5] relative">
              <img
                src={s.img}
                alt={`${s.title} — sign of termite infestation`}
                className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 w-9 h-9 flex items-center justify-center bg-[#C05746] text-[#F9F7F4] font-display text-sm z-10 shadow-md">
                0{i + 1}
              </div>
              <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
            </div>
            <h3 className="font-display text-[#1C1B1A] text-2xl md:text-3xl mt-5 tracking-tight">
              {s.title}
            </h3>
            <p className="text-[#5C5A55] text-sm md:text-base leading-relaxed mt-2">
              {s.desc}
            </p>
          </motion.article>
        ))}
      </div>

      <div className="mt-16 md:mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-[#E5DFD5] pt-10">
        <p className="font-display text-2xl md:text-3xl text-[#1C1B1A] max-w-2xl leading-tight">
          Seeing any of these at home?{" "}
          <span className="font-serif-accent italic text-[#C05746]">Don't wait.</span>
        </p>
        <a
          href={SITE.phoneHref}
          data-testid="threat-call-button"
          className="cta-shimmer inline-flex items-center gap-3 bg-[#C05746] hover:bg-[#A64B3C] text-[#F9F7F4] px-7 py-5 font-semibold tracking-[0.1em] uppercase text-sm transition-colors"
        >
          <Phone size={18} strokeWidth={2.5} /> Call {SITE.phoneDisplay}
        </a>
      </div>
    </div>
  </section>
);
